import axios from "axios";

import { API_BASE_URL as API_BASE } from "../config";

// --- Serviços ---
export async function getServicos(idClienteMaster) {
  const res = await axios.get(`${API_BASE}/Servicos`, { params: { idClienteMaster } });
  return res.data;
}

// --- Horários disponíveis ---
export async function getHorariosDisponiveis({ idClienteMaster, idFuncionario, idServico, from, to }) {
  if (!idFuncionario) throw new Error("idFuncionario é obrigatório para buscar horários.");
  if (!idServico) throw new Error("idServico é obrigatório para buscar horários.");
  const res = await axios.get(`${API_BASE}/Horarios/disponiveis`, {
    params: { idClienteMaster, idFuncionario, idServico, from, to },
  });
  return res.data;
}

// --- Clientes ---
export async function getClienteByPhone(phoneDigits, idClienteMaster) {
  // espera-se um endpoint GET /api/Clientes/by-phone?phone=...&idClienteMaster=...
  const res = await axios.get(`${API_BASE}/Clientes/by-phone`, {
    params: { phone: phoneDigits, idClienteMaster },
    validateStatus: (s) => s >= 200 && s < 500,
  });
  if (res.status === 404) return null;
  return res.data;
}

export async function criarCliente({ nome, telefone, clienteMasterId }) {
  try {
    const emailCliente = `${nome.replace(/\s+/g, '').toLowerCase()}@sememail.com`;

    const jsonBody = {
      nome,
      telefone,
      email: emailCliente,
      clienteMasterId,
      clienteMaster: {
        id: clienteMasterId
      }
    };

    const res = await axios.post(`${API_BASE}/Clientes`, jsonBody);
    return res.data;
  } catch (error) {
    console.error("ERRO AO CRIAR CLIENTE:", error.response?.data || error.message);
    throw error;
  }
}



// --- Dashboard ---
export async function getDashboardPrincipal(idClienteMaster, idFuncionario = null) {
  const params = { idClienteMaster };
  if (idFuncionario) {
    params.idFuncionario = idFuncionario;
  }
  const res = await axios.get(`${API_BASE}/Dashboard/principal/${idClienteMaster}`, { params });
  return res.data;
}

export async function getAdminAnalytics(idClienteMaster) {
  const res = await axios.get(`${API_BASE}/Dashboard/admin-analytics/${idClienteMaster}`);
  return res.data;
}

// --- Agendamento ---
export async function getClienteMasterBySlug(slug) {
  try {
    const res = await axios.get(`${API_BASE}/ClienteMaster/${slug}`);
    return res.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Se o backend retornar 401 (Unauthorized) com a mensagem de inatividade,
      // vamos retornar o objeto com ativo: false para que o frontend possa exibir o overlay.
      // Para isso, precisamos buscar o cliente master sem a verificação de ativo.
      // O endpoint GET /ClienteMaster/{slug} não deveria ter a verificação de ativo,
      // apenas o endpoint de agendamento e login.
      // Vou assumir que o endpoint GET /ClienteMaster/{slug} retorna o cliente master
      // mesmo que inativo, e o campo 'ativo' será verificado no frontend.
      // Se o erro 401 estiver vindo do endpoint de agendamento, a lógica está no lugar errado.
      // Vou assumir que o endpoint GET /ClienteMaster/{slug} retorna o cliente master
      // e o campo 'ativo' é o que deve ser verificado.
      // O erro 401 que o usuário viu deve ter sido no endpoint de agendamento.
      // Vou manter a lógica no frontend para verificar o campo 'ativo' que foi adicionado.
      // Se o endpoint GET /ClienteMaster/{slug} retornar 404, o erro já é tratado.
      // Se o endpoint retornar 401, é um erro inesperado aqui.
      // Vou manter a implementação anterior e focar na correção do `InicioOpcoes.js`
      // para garantir que ele leia o campo `ativo` corretamente.
      // O problema pode ser que o backend não está retornando o campo 'ativo' no GET by slug.
      // Vou verificar o ClienteMasterController.cs novamente.
      throw error;
    }
    throw error;
  }
}

export async function criarAgendamento(payload) {
  // payload: { idClienteMaster, idCliente, idServico, idFuncionario, data, observacao }
  const res = await axios.post(`${API_BASE}/Agendamentos`, payload);
  return res.data;
}
